import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { LANGUAGE_EN } from '../constants';
/**
 * This hook returns language from Sitecore Context
 * @returns {string} Current language
 */
const useLanguage = () => {
    var _a;
    const { sitecoreContext } = useSitecoreContext();
    return (_a = sitecoreContext.language) !== null && _a !== void 0 ? _a : LANGUAGE_EN; // default language
};
export default useLanguage;
